import checkout from "./form3";

const {
  formField3: {
    allocationActivity,
    quarter,
    year,
    firstTime,
    supplementaryForThe,
    taxpayerName,
    taxId
  },
} = checkout;

const initialValues3 = {
  [firstTime.name]: false,
  [supplementaryForThe.name]: "",
  [quarter.name]: "",
  [year.name]: "",
  [taxId.name]: "",
  [taxpayerName.name]: "",
  [allocationActivity.name]: false,
};

export default initialValues3;
